"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfiguracaoObservacaoSku = void 0;
var bson_1 = require("bson");
var ConfiguracaoObservacaoSku = /** @class */ (function () {
    function ConfiguracaoObservacaoSku(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.descricao, descricao = _c === void 0 ? '' : _c, _d = _a.marca, marca = _d === void 0 ? [] : _d, _e = _a.estacaoColecao, estacaoColecao = _e === void 0 ? [] : _e, _f = _a.linhaDeProduto, linhaDeProduto = _f === void 0 ? [] : _f, _g = _a.destinoDeConfeccao, destinoDeConfeccao = _g === void 0 ? [] : _g, _h = _a.categoriaProduto, categoriaProduto = _h === void 0 ? [] : _h, _j = _a.material, material = _j === void 0 ? [] : _j, _k = _a.quantidade, quantidade = _k === void 0 ? 0 : _k, _l = _a.pv, pv = _l === void 0 ? [] : _l, _m = _a.tipoDeProduto, tipoDeProduto = _m === void 0 ? [] : _m, _o = _a.tamanhos, tamanhos = _o === void 0 ? [] : _o, _p = _a.cores, cores = _p === void 0 ? [] : _p, _q = _a.observacao, observacao = _q === void 0 ? '' : _q;
        this._id = _id;
        this.descricao = descricao;
        this.marca = marca;
        this.estacaoColecao = estacaoColecao;
        this.linhaDeProduto = linhaDeProduto;
        this.destinoDeConfeccao = destinoDeConfeccao;
        this.categoriaProduto = categoriaProduto;
        this.material = material;
        this.quantidade = quantidade;
        this.pv = pv;
        this.tipoDeProduto = tipoDeProduto;
        this.tamanhos = tamanhos;
        this.observacao = observacao;
        this.cores = cores;
    }
    return ConfiguracaoObservacaoSku;
}());
exports.ConfiguracaoObservacaoSku = ConfiguracaoObservacaoSku;
//# sourceMappingURL=ConfiguracaoObservacaoSku.js.map